import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyChooseUs from "@/components/WhyChooseUs";
import Services from "@/components/Services";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Coverage from "@/components/Coverage";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import StickyBottomBar from "@/components/StickyBottomBar";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function HomePage() {
  return (
    <div data-testid="home-page" className="font-body bg-moffat-bg">
      <Navbar />
      <main>
        <Hero />
        <WhyChooseUs />
        <Services />
        <About />
        <Testimonials />
        <Coverage />
        <QuoteForm />
      </main>
      <Footer />
      <StickyBottomBar />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{ duration: 4500 }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
